import {signal} from "@preact/signals-core";
import {IChar} from "../_interfaces/IChar";

export const s_chars = signal(new Map<string, IChar>());
